import { Directive, HostBinding, HostListener, Input, OnDestroy } from '@angular/core';
import { copyToClipboard } from '../../utils/clipboard-util';

@Directive({
  selector: 'button[appCopyValue]',
  standalone: false
})
export class CopyValueDirective implements OnDestroy {
  @Input() public appCopyValue: string;

  @HostBinding('disabled')
  public get disabled(): boolean {
    return this.cooldown;
  }

  @HostBinding('class.app-copy-value')
  public alwaysOnClass = true;

  @HostBinding('class.app-copy-value--copied')
  public get copied(): boolean {
    return this.cooldown;
  }

  private readonly cooldownDuration = 3000;
  private cooldown = false;
  private cooldownTimer: NodeJS.Timeout;

  @HostListener('click')
  public onClick(): void {
    if (this.copied) {
      return;
    }

    this.copy();
    this.cooldown = true;
    this.cooldownTimer = setTimeout(() => {
      this.cooldown = false;
    }, this.cooldownDuration);
  }

  public ngOnDestroy() {
    clearTimeout(this.cooldownTimer);
  }

  private copy() {
    copyToClipboard(this.appCopyValue);
  }
}
